import { useBreakpointValue } from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState, useContext } from "react";
import { useNavigate, useSubmit } from "react-router-dom";
import * as Constants from "../../constants/Constants";
import { isValidArray } from "../../helpers/utils/Utils";
import store from "../../store/store";
import GrubToastMessage from "../alert/GrubToastMessage";
import { checkTodayTimeSlot } from "../../helpers/delivery/delivery";
import moment from "moment";
import { getAllLocations } from "../../modules/home/services/HomeServices";
import GrubErrorHook from "../../hooks/routeError/GrubErrorHook";
import AppContext from "../../components/appcontex/AppContext";

export const useGrubCartDialogDrawer = (props) => {
    // Hooks
    const submit = useSubmit();
    const navigate = useNavigate();
    const { addToast } = GrubToastMessage();
    const { error } = GrubErrorHook();
    const myContext = useContext(AppContext);
    // States
    const [isOpenes, setIsOpenModal] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isTimeSlotModalOpen, setTimeSlotModalOpen] = useState(false);

    //Refs
    const cancelRef = useRef();
    const touchedRef = useRef([]);

    const limit = useBreakpointValue({
        base: 40,
        md: 35,
    });

    const formik = useFormik({
        initialValues: {
            instruction: props.order_items.map((item) => ({
                key: item.server_id,
                value: item?.description || "",
            })),
        },
        validate: (values) => {
            let errors = { instruction: [] };
            if (
                isValidArray(values?.instruction) &&
                values?.instruction?.length > 0
            ) {
                values.instruction.forEach((item) => {
                    if (item.value.length > 255) {
                        errors.instruction.push({
                            key: item.key,
                            value: Constants.VALID_SPECIAL_INSTRUCTION,
                        });
                    }
                });
            }
            return errors;
        },
        onSubmit: (values) => {
            submit(values, {
                method: Constants.POST,
                path: Constants.Products,
            });
        },
    });

    useEffect(() => {
        let instruction = props.order_items.map((item) => ({
            key: item.new_identity,
            value: item?.description || "",
        }));
        formik.setFieldValue("instruction", instruction);
        touchedRef.current = [];
    }, [props.isOpen]);

    const handleAlertModalOpen = () => {
        if (props.order_items?.length > 0) {
            setIsOpenModal(true);
        }
    };

    const handleDeleteRow = (item) => {
        if (props.payments.length > 0) {
            addToast({
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: Constants.HALF_PAYMENT,
            });
            return;
        }
        props.deleteItem(item);
        props.orderCalculation();
        if (
            isValidArray(formik?.values?.instruction) &&
            formik?.values?.instruction?.length > 0
        ) {
            formik.setFieldValue(
                "instruction",
                formik.values.instruction.filter(
                    (instruction) => instruction.key !== item.new_identity
                )
            );
        }
        if (isValidArray(touchedRef.current) && touchedRef.current.length > 0) {
            touchedRef.current = touchedRef.current.filter(
                (instruction) => instruction.key !== item.new_identity
            );
        }
        if (
            isValidArray(formik?.errors?.instruction) &&
            formik?.errors?.instruction?.length > 0
        ) {
            formik.setErrors(
                "instruction",
                formik.errors.instruction.filter(
                    (instruction) => instruction.key !== item.new_identity
                )
            );
        }
        if (props.order_items?.length <= 1) {
            props.onClose();
        }
    };

    const handleInstructionChange = (item, value) => {
        let valueIndex;
        let touchIndex;
        if (
            isValidArray(formik?.values?.instruction) &&
            formik?.values?.instruction?.length > 0
        ) {
            valueIndex = formik.values.instruction.findIndex(
                (instruction) => instruction.key === item.new_identity
            );
        }
        if (isValidArray(touchedRef.current) && touchedRef.current.length > 0) {
            touchIndex = touchedRef.current.findIndex(
                (instruction) => instruction.key === item.new_identity
            );
        }
        if (value.length <= 255) {
            props.updateItemInstruction(item, value.trim());
        } else {
            props.updateItemInstruction(item, "");
        }
        if (valueIndex > -1) {
            formik.setFieldValue("instruction", [
                ...formik.values.instruction.slice(0, valueIndex),
                { key: item.new_identity, value: value },
                ...formik.values.instruction.slice(valueIndex + 1),
            ]);
        } else {
            let instructionObj = {
                key: item.new_identity,
                value: value,
            };
            formik.setFieldValue("instruction", [
                ...formik.values.instruction,
                instructionObj,
            ]);
        }
        if (touchIndex > -1) {
            let allTouched = [
                ...touchedRef.current.slice(0, touchIndex),
                { key: item.new_identity, value: true },
                ...touchedRef.current.slice(touchIndex + 1),
            ];
            touchedRef.current = allTouched;
        } else {
            let touchObj = {
                key: item.new_identity,
                value: true,
            };
            let array =
                undefined !== touchedRef.current
                    ? [...touchedRef.current, touchObj]
                    : [touchObj];
            touchedRef.current = array;
        }
    };

    const handleOpenModal = () => {
        props.onClose();
        setModalOpen(true);
    };

    const handleAddQuantity = (item) => {
        if (props.payments.length > 0) {
            addToast({
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: Constants.HALF_PAYMENT,
            });
            return;
        }
        props.addItem(item);
        props.orderCalculation(); // Reducer call to store order data
    };

    const handleMinusQuantity = (item) => {
        if (props.payments.length > 0) {
            addToast({
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: Constants.HALF_PAYMENT,
            });
            return;
        }
        props.minusItem(item);
        props.orderCalculation(); // Reducer call to store order data
        if (store.getState().order_items.length === 0) {
            props.onClose();
        }
    };

    const handleAllDelete = () => {
        if (props.payments.length > 0) {
            addToast({
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: Constants.HALF_PAYMENT,
            });
            return;
        }
        formik.setFieldValue("instruction", []);
        touchedRef.current = [];
        formik.setErrors("instruction", []);
        props.clearItems();
        props.onClose();
        setIsOpenModal(false);
    };

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleCloseModal = (isLogin) => {
        if (isLogin) {
            setModalOpen(false);
            if (props.order_items.length > 0) {
                navigate(
                    `/${localStorage.getItem("tenant")}` +
                        Constants.CHECKOUT_PATH
                );
            }
        } else if (!isLogin) {
            setModalOpen(false);
        }
    };

    const handleCheckout = () => {
        let isError = false;
        setTimeSlotModalOpen(false);
        const errors = formik.errors.instruction || [];
        if (errors.length > 0) {
            errors.forEach((error) => {
                if (error.value.length > 0) {
                    isError = true;
                }
            });
        }
        if (isError) {
            addToast({
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: Constants.VALID_SPECIAL_INSTRUCTION,
            });
        } else {
            if (props.user && Object.keys(props.user).length > 0) {
                props.order_items.forEach((item) => {
                    let findIndex = formik.values.instruction.findIndex(
                        (instruction) => instruction.key === item.new_identity
                    );
                    if (findIndex > -1) {
                        props.updateItemInstruction(
                            item,
                            formik.values.instruction[findIndex]?.value.trim()
                        );
                    }
                });
                if (props.order_items.length > 0) {
                    const scrollToTop = () => {
                        // Try multiple scroll methods for maximum compatibility
                        const scrollOptions = { top: 0, behavior: "smooth" };

                        // Method 1: scrollTo on various elements
                        if ("scrollTo" in window) {
                            window.scrollTo(scrollOptions);
                        }

                        // Method 2: scrollIntoView on the top element
                        const topElement =
                            document.getElementById("top") || document.body;
                        if (topElement.scrollIntoView) {
                            topElement.scrollIntoView({ behavior: "smooth" });
                        }

                        // Method 3: Manual scroll for iOS
                        const duration = 500; // ms
                        const start = window.pageYOffset;
                        const startTime =
                            "now" in window.performance
                                ? performance.now()
                                : new Date().getTime();

                        const scroll = () => {
                            const currentTime =
                                "now" in window.performance
                                    ? performance.now()
                                    : new Date().getTime();
                            const time = Math.min(
                                1,
                                (currentTime - startTime) / duration
                            );

                            window.scrollTo(0, Math.ceil((1 - time) * start));

                            if (time < 1) {
                                requestAnimationFrame(scroll);
                            }
                        };

                        requestAnimationFrame(scroll);
                    };

                    // Execute scroll and continue
                    scrollToTop();
                    navigate(
                        `/${localStorage.getItem("tenant")}` +
                            Constants.CHECKOUT_PATH
                    );
                    props.onClose();
                }
            } else {
                handleOpenModal();
            }
        }
    };

    const calculateNextTimeSlot = (deliveryDetails) => {
        deliveryDetails[0]?.location?.location_online_order_settings.forEach((onlineSettings) => {
            const [hours, minutes, seconds] = deliveryDetails[0]?.order_type === "pickup"
                ? onlineSettings.pickup_lead_time.split(":")
                : onlineSettings.delivery_lead_time.split(":");

            const finalTime = moment().add(hours, 'hours').add(minutes, 'minutes').add(seconds, 'seconds').format('hh:mm A');
            const currentTime = moment().format('hh:mm A');
            const storeOpenTime = onlineSettings.location_hrs_sub_slot[0].from_time;
            const storeCloseTime = onlineSettings.location_hrs_sub_slot[onlineSettings.location_hrs_sub_slot.length - 1].to_time;

            if (moment(currentTime, ["h:mm A"]).isBefore(moment(storeOpenTime, ["h:mm A"]))) {
                if (deliveryDetails[0]?.scheduleOrder === "custom") {
                    props.onClose();
                    addToast({
                        alertStatus: Constants.TOAST_TYPE_ERROR,
                        alertTitle: "",
                        alertDescription: Constants.STORE_OPEN_BEFORE_ORDER_START,
                        isBottomToast: true,
                    });
                    return;
                } else {
                    handleCheckout();
                }
            } else if (moment(currentTime, ["h:mm A"]).isAfter(moment(storeCloseTime, ["h:mm A"]))) {
                props.onClose();
                addToast({
                    alertStatus: Constants.TOAST_TYPE_ERROR,
                    alertTitle: "",
                    alertDescription: Constants.STORE_CLOSE_AFTER_ORDER_START,
                    isBottomToast: true,
                });
                return;
            }

            const findTimeSlot = onlineSettings.location_hrs_sub_slot.find(slot => slot.id == deliveryDetails[0].DeliveryTime?.id);
            if (deliveryDetails[0]?.scheduleOrder === "custom") {
                if (findTimeSlot) {
                    if (moment(findTimeSlot?.from_time, ["h:mm A"]).isBefore(moment(finalTime, ["h:mm A"]))) {
                        props.onClose();
                        setTimeSlotModalOpen(true);
                    } else {
                        handleCheckout();
                    }
                } else {
                    props.onClose();
                    setTimeSlotModalOpen(true);
                }
            } else {
                handleCheckout();
            }
        });
    };

    const handleCheckTimeSlot = () => {
        const errors = formik.errors.instruction || [];
        const isError = errors.some(error => error.value.length > 0);
        if (isError) {
            addToast({
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: Constants.VALID_SPECIAL_INSTRUCTION,
            });
        } else {
            const DeliveryPickupDetails = [...props.delivery_pickup];
            const locations = [DeliveryPickupDetails?.location];
            const isSameDay = checkTodayTimeSlot(DeliveryPickupDetails);
            if (locations.length > 0 && isSameDay) {
                calculateNextTimeSlot(DeliveryPickupDetails);
            } else {
                props.onClose();
                myContext.handleLoading(true);
                getAllLocations().then((loaderResponse) => {
                    if (loaderResponse?.error) {
                        error({ actionData: loaderResponse });
                        myContext.handleLoading(false);
                    } else if (loaderResponse.data[Constants.FLAGE]) {
                        const locations = loaderResponse.data[Constants.DATA];
                        const locationData = locations.find(location => location.id === DeliveryPickupDetails[0]?.location?.id);
                        if (locationData) {
                            const orderDetails = {
                                ...props.delivery_pickup[0],
                                location: locationData,
                            };
                            props.addDeliveryPickupDetails(orderDetails);
                            myContext.handleLoading(false);
                            calculateNextTimeSlot([orderDetails]);
                        } else {
                            props.clearItems();
                            props.removeDeliveryPickupDetails();
                            props.onClose();
                            navigate(`/${localStorage.getItem("tenant")}`);
                        }
                    }
                });
            }
        }
    };

    const handleTimeSlotClose = () => {
        setTimeSlotModalOpen(false);
    };

    return {
        isModalOpen,
        formik,
        isOpenes,
        touchedRef,
        cancelRef,
        limit,
        isTimeSlotModalOpen,
        handleCloseModal,
        handleAddQuantity,
        handleMinusQuantity,
        handleDeleteRow,
        handleInstructionChange,
        handleAlertModalOpen,
        handleAllDelete,
        handleClose,
        handleCheckout,
        addToast,
        handleCheckTimeSlot,
        handleTimeSlotClose,
    };
};
